import {VuexModule, Mutation, Action, getModule, Module} from 'vuex-module-decorators';
import {WidgetCard, LayoutCard} from '@/views/dashboard/interfaces';
import store from '@/store';

/*
    Динамический модуль хранилища vuex для работы с виджетами
*/

const moduleName = 'widgetModule';

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class WidgetModule extends VuexModule {
  /*
    Ключ для подписки на изменение
  */
  changedKey = 0;

  /*
    Мутация на добавление виджета
  */
  @Mutation
  saveEditWidgetMutation(widget: WidgetCard) {
    //сохраняем в готовых виджетах
    const value = window.localStorage.getItem('widgets');
    let widgets: WidgetCard[] = [];
    if (value) widgets = JSON.parse(value);

    widgets = widgets.filter((x: WidgetCard) => x.id !== widget.id);
    widgets.push(widget);
    window.localStorage.setItem('widgets', JSON.stringify(widgets));

    //сохраняем в пользовательских настройках дашборда
    const value2 = window.localStorage.getItem('userDashboard');
    let cards: LayoutCard[] = [];
    if (value2) cards = JSON.parse(value2);
    cards = cards.filter((x: LayoutCard) => x.id !== widget.id);
    cards.push(widget);
    window.localStorage.setItem('userDashboard', JSON.stringify(cards));
    this.changedKey++;
  }

  /*
    Действие на добавление виджета
  */
  @Action
  saveEditWidget(widget: WidgetCard) {
    this.context.commit('saveEditWidgetMutation', widget);
  }

  /*
    Действие на получение списка виджетов
  */
  @Action
  getWidgets() {
    const value = window.localStorage.getItem('widgets');
    let widgets: WidgetCard[] = [];
    if (value) widgets = JSON.parse(value);
    return widgets;
  }
}

export default getModule(WidgetModule);
